import React, { Component } from 'react'
import Container from './Container';
import HomePoster from './HomePoster';

export default class Home extends Component {

    
    
    render() {
    
        const props = this.props;
     
        return (
            <div>
                 <div className="main">

      {props.home.bollywood.length&&<Container
          {...props} dispatch={props.dispatch} title='Bollywood' data={props.home.bollywood}
      />}
     {props.home.hollywood.length&&<Container
          {...props} dispatch={props.dispatch} title='Hollywood' data={props.home.hollywood}
     />}
      {props.home.action.length&&<Container
           {...props} dispatch={props.dispatch} title='Action' data={props.home.action}
      />}
      {(props.home.trending.title)&&<HomePoster
           {...props} dispatch={props.dispatch} data={props.home.trending}
      />}
     {props.home.horror.length&&<Container
          {...props} dispatch={props.dispatch} title='Horror' data={props.home.horror}
     />}
      {props.home.comedy.length&&<Container
           {...props} dispatch={props.dispatch} title='Comedy' data={props.home.comedy}
      />}
    </div>
    
            </div>
        )
    }
}
